import { COOKIE_CHANGED } from './actionTypes';

export function cookieObserverReducer(state = null, action) {
  if (action.type === COOKIE_CHANGED) return action.payload;
  return state;
}
